import { formControlLabelClasses } from '@mui/material/FormControlLabel';
import { radioClasses } from '@mui/material/Radio';
import { useTheme } from '../../../../theme';
import { type CSSObject } from '@emotion/react';

export const useRadioButtonLabelStyles = (): CSSObject => {
  const theme = useTheme();
  return {
    [`&.${formControlLabelClasses.root}`]: {
      gap: '8px',
    },
    [`& .${formControlLabelClasses.label}`]: {
      color: theme.text.generic.primary,

      [`&.${formControlLabelClasses.disabled}`]: {
        color: theme.text.interactive.disabled,
      },
    },
  };
};

export const useRadioButtonBaseStyles = (): CSSObject => ({
  [`&.${radioClasses.root}`]: {
    height: 20,
    width: 20,

    'input[type="radio"]': {
      position: 'absolute',
      height: 20,
      width: 20,
      opacity: 0,
      top: 0,
      left: 0,
      zIndex: 1,
    },
  },
});
